module.exports = __webpack_public_path__ + "static/media/New_Brand_Profiles.f0499e38.svg";